module.exports = __webpack_public_path__ + "7c52861e735507a6ce3f5508a95482b9.svg";